import { Instance, SnapshotIn, types } from "mobx-state-tree";
import {
  BoundedNameModel,
  createBoundedNameModel,
} from "../../models/BoundedNameModel";
import {
  createEmailTemplateContentModel,
  EmailTemplateContentModel,
} from "../../emailTemplates/models/EmailTemplateContentModel";
import { EmailContent } from "@pulse/pulse-rpcs/lib/email-cycle/emailContent";

export const EmailContentModel = types
  .model("EmailContentModel", {
    subject: BoundedNameModel,
    body: EmailTemplateContentModel,
  })
  .views((store) => ({
    get rpcObject(): EmailContent {
      return new EmailContent(store.subject.rpcObject, store.body.rpcObject);
    },
  }));

export const createEmailContentModel = (
  emailContent?: SnapshotIn<typeof EmailContentModel>,
): Instance<typeof EmailContentModel> =>
  EmailContentModel.create(
    emailContent ?? {
      subject: createBoundedNameModel(),
      body: createEmailTemplateContentModel(),
    },
  );
